import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { colorToArray, generateRouletteCanvas, getLayout, i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';

import RouletteCanvas from '../games/RouletteCanvas';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';

const ContainedRoulette = forwardRef((props, ref) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const container_id = 'roulette_container';
	const [ is_dom_loaded, setIsDomLoaded ] = useState(false);

	const roulette_ref = useRef();
	const previous_num_slices = useRef(0);

	const is_builder = props?.is_builder ?? false;

	useImperativeHandle(ref, () => ({
		getSliceImageSize() {
			return roulette_ref.current.getSliceImageSize();
		},

		openExportImageLayer() {
			roulette_ref.current.openExportImageLayer();
		},

		getCanvas() {
			return roulette_ref.current.getCanvas();
		},
	}));

	const stage = props?.stage ?? false;
	if(!stage) return false;

	useEffect(() => {
		setIsDomLoaded(true);
	}, []);

	const convertPrizeToSlices = () => {
		if(isNotEmpty(stage, 'roulette_order')) return stage.roulette_order;
		
		const slices = [];
		const slices_definition = generateRouletteCanvas(props.prizes, {
			slices:stage.roulette_slices,
			no_prize:stage.roulette_no_prize,
			uniform:stage?.roulette_distribution == 'uniform'
			//odds:stage.roulette_odds ?? false,	// REVIEW THIS AFTER XMAS.
		});

		slices_definition.map((slice, s) => {
			slices.push({ id:s, prize:slice.id });
		});

		if(props.updateNumSlices != undefined && slices.length != previous_num_slices.current) {
			previous_num_slices.current = slices.length;
			props.updateNumSlices(previous_num_slices.current);
		}

		return slices;
	};

	const slices = convertPrizeToSlices();

	const layout_props = getLayout(props.promotion);

	const is_demo = props?.is_demo ?? false;

	//const bgimg = (!is_demo && !props.is_export) ? (stage?.full_roulette_custom_bg ?? '/fla_canvas/roulette/images/roulette_bg_demo.jpg') : false;
	const bgimg = (!is_demo && !props.is_export) ? (stage?.full_roulette_custom_bg ?? false) : false;
	const bg_color = (!is_demo && !props.is_export) ? (stage?.roulette_background_color ?? layout_props.color.background_color) : false;
	const roulette_description = (!is_demo && !props.is_export && isNotEmpty(props, 'roulette_description')) ? props.roulette_description : false;

	let final_prizes = {
		'0':{
			color:stage?.roulette_no_prize_color ?? '#000000',
			name:stage?.roulette_no_prize_label ?? i18n("No prize"),
		}
	};

	if(stage.roulette_no_prize_image != undefined) {
		final_prizes[0].image = stage.roulette_no_prize_image;
		final_prizes[0].full_image = stage.full_roulette_no_prize_image;
	}

	for(var i in props.prizes) {
		let pt = { name:props.prizes[i].title,id:props.prizes[i].id };
		let pt_roulette_data = stage.roulette_data[props.prizes[i].id];
		if(pt_roulette_data == undefined) {
			pt.color = '#C3C2C1';
			pt.image = '';
		} else {
			pt.color = pt_roulette_data?.color ?? "#C3C2C1";
			if(pt_roulette_data.image != undefined) {
				pt.image = pt_roulette_data.image;
				pt.full_image = pt_roulette_data.full_image;
			}
			if(pt_roulette_data.given_prize_image != undefined) {
				pt.given_prize_image = pt_roulette_data.given_prize_image;
				pt.full_given_prize_image = pt_roulette_data.full_given_prize_image;
			}
		}
		final_prizes[props.prizes[i].id] = pt;
	}

	if(props.prizes.length == 0) return null;

	const given_prize = (props.given_prize != undefined) ? props.given_prize : props.prizes[Math.floor(Math.random() * props.prizes.length)].id;

	const canvas_images =() => {
		const images = [];

		if(isNotEmpty(stage, 'roulette_logo') && isNotEmpty(stage, 'full_roulette_logo')) {
			images.push({
				id:`logo`,
				name:stage.roulette_logo,
				url:stage.full_roulette_logo,
				fit:'cover',
			});
		}

		if(isNotEmpty(stage, 'given_no_prize_image') && isNotEmpty(stage, 'full_given_no_prize_image')) {
			images.push({
				id:`final_0`,
				name:stage.given_no_prize_image,
				url:stage.full_given_no_prize_image,
				fit:'contain',
			});
		}/* else if(isNotEmpty(stage, 'roulette_no_prize_image') && isNotEmpty(stage, 'full_roulette_no_prize_image')) {
			images.push({
				id:`final_0`,
				name:stage.roulette_no_prize_image,
				url:stage.full_roulette_no_prize_image,
				fit:'contain',
			});
		}*/

		Object.values(final_prizes).map((pt) => {
			if(isNotEmpty(pt, 'image') && isNotEmpty(pt, 'full_image')) {
				images.push({
					id:`pt_${pt?.id ?? '0'}`,
					name:pt.image,
					url:pt.full_image,
					fit:'cover',
				});
			}

			if(isNotEmpty(pt, 'given_prize_image') && isNotEmpty(pt, 'full_given_prize_image')) {
				images.push({
					id:`final_${pt?.id ?? '0'}`,
					name:pt.given_prize_image,
					url:pt.full_given_prize_image,
					fit:'contain',
				});
			}
		});

		return images;
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[props.prizes],
	});

	return (
		<div id={container_id} class={'roulette_container' + ((is_builder) ? ' is_builder' : '')}>
			{(roulette_description) && (
				<h1 class="roulette_intro" dangerouslySetInnerHTML={{ __html:roulette_description.replace(/\n/g, '<br />') }} />
			)}

			{(bg_color !== false && bgimg === false) && (
				<div id="roulette_bg" class="roulette_bg" style={{ backgroundColor:`rgba(${colorToArray(bg_color)}, 1)` }} />
			)}

			{(bgimg !== false) && (
				<div class="roulette_bg" style={{ backgroundImage:`url(${bgimg})` }} />
			)}

			<div class="whole_roulette_container">
				{(is_dom_loaded && state.state == 'LOADED') && (
					<RouletteCanvas
						ref={roulette_ref}
						indexed_images={state.images}
						is_builder={is_builder}
						prize_types={final_prizes}
						slices={slices}
						is_playable={!is_demo}
						is_demo={is_demo}
						stage={stage}
						debug_mode={false}
						given_prize={given_prize}
						parent_id={container_id}
						layout_props={layout_props}
						end_animation_cb={props.end_animation_cb}
						is_export={props.is_export}
						export_type={props.export_type}
						main_cta={props.main_cta}
					/>
				)}
			</div>
		</div>
	);
})

export default injectIntl(ContainedRoulette, { withRef:true });